<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-06 14:54:28
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-15 13:47:46
 * @FilePath: /chaoyongtuan/src/views/shopManage/shopLibrary/addMaterial/components/good/tableCells/showMoreCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<div class="omit cursor-pointer">
			<el-popover placement="right" width="660" trigger="hover" >
				<moreList :show="show" :key="updataState" :list="row.multiterm" @settingCallback="onSetting"></moreList>
				<span slot="reference">
					<slot name="popover"><span @click="onCountClick" class="fz-12">{{!showElliptical ? row.count : '...' }}</span></slot>
				</span>
			</el-popover>
		</div>
	</div>
</template>
<script>
import moreList from '../components/moreList.vue';
export default {
	inject: {
		injectSettingComssion: {
			default: () => {
				return () => {};
			},
		},
		
	},
	props: {
		row: {
			type: Object,
			default: () => {},
		},
		showElliptical: {
			type: Boolean,
			default: false,
		},
		show:{
			type: Boolean,
			default: false,
		}
	},
	data() {
		return {
			updataState: false,
		};
	},
	components: {
		moreList,
	},
	computed: {
		multiType() {
			return this.row.type;
		},
	},

	mounted() {},

	methods: {
		onCountClick(){
			this.updataState = !this.updataState;
		},
		onSetting(row) {
			this.updataState = false;
			this.$nextTick(()=>{
				this.injectSettingComssion(row);
				this.updataState = true;
			})
		},
	},
};
</script>
<style lang="less" scoped>
.show-elliptical,
.omit {
	color: @color-b4;
}
</style>
